import { useState, useEffect } from 'react';

// Source unique de vérité pour le seuil mobile/desktop.
// Alignée sur le breakpoint `md` par défaut de Tailwind (voir tailwind.config.js) :
// si l'un des deux change, l'autre doit être mis à jour en conséquence.
export const MOBILE_BREAKPOINT = 768;

const getQuery = () => `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const getInitialIsMobile = () => {
  if (typeof window === 'undefined') return false;
  return typeof window.matchMedia === 'function'
    ? window.matchMedia(getQuery()).matches
    : window.innerWidth < MOBILE_BREAKPOINT;
};

/**
 * Détecte si le viewport courant est en dessous du breakpoint mobile.
 * Utilise `matchMedia` (déclenché uniquement quand le résultat change,
 * donc naturellement "debounced" contrairement à un listener `resize` brut).
 */
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(getInitialIsMobile);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mediaQueryList = window.matchMedia(getQuery());
    const handleChange = (event) => setIsMobile(event.matches);

    setIsMobile(mediaQueryList.matches);

    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener('change', handleChange);
      return () => mediaQueryList.removeEventListener('change', handleChange);
    }

    // Fallback pour anciens navigateurs (Safari < 14) sans addEventListener sur MediaQueryList.
    mediaQueryList.addListener(handleChange);
    return () => mediaQueryList.removeListener(handleChange);
  }, []);

  return isMobile;
}
